import { ListConfig } from '../types'

export const buildListOptions = (list: ListConfig | undefined): ListConfig => {
  return {
    fields: ['name', 'description', 'updatedAt'],
    details: [],
    ...list
  }
}
